function fontFun() {
    var winW = document.documentElement.clientWidth;//浏览器可视宽度
    document.documentElement.style.fontSize = (winW / 750 * 625) + "%";
}
fontFun();
window.onresize = fontFun;


// WEBPACK FOOTER //
// ./src/utils/rem.js